import React from "react";
import { isEmpty } from "lodash";
import { Checkbox, Box, Grid, Button } from "@material-ui/core";
import { Typography, FormControlLabel } from "@material-ui/core";
import SentimentDissatisfiedIcon from "@material-ui/icons/SentimentDissatisfied";
// component
import { getCurrency } from "helper/numberFormat";
// direct import
import "../style.scss";

const AddOns = ({ values }) => {
  const currency = getCurrency();

  const getAddOns = values
    ?.filter((amount) => amount?.amount !== 0 && amount?.amount !== "")
    ?.map((el) => {
      return {
        label: el?.title,
        amount: el?.amount,
      };
    });

  const isOpenAmount = values?.find((el) => el?.openAmount === true);

  return (
    <Box className="summary-renewal__card">
      <Typography className="summary-renewal__title">Add-ons</Typography>
      <Grid container spacing={2}>
        {getAddOns?.map((option, index) => {
          return (
            <Grid item xs={6} key={index}>
              <Button
                fullWidth
                variant="outlined"
                className="summary-renewal__option-button"
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  width="100%"
                  minWidth={0}
                >
                  <Typography noWrap title={option.label} style={{ minWidth: 0 }}>
                    {option.label}:
                  </Typography>
                  <Typography style={{ flexShrink: 0 }}>
                    {currency}
                    {Number(option.amount).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                </Box>
              </Button>
            </Grid>
          );
        })}
      </Grid>
      {isEmpty(getAddOns) && (
        <Box
          sx={{
            flexDirection: "column",
            height: 100,
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <SentimentDissatisfiedIcon fontSize="large" />
          <Typography variant="h6">No data available.</Typography>
        </Box>
      )}
      {isOpenAmount && (
        <Box className="summary-renewal__checkbox-container" mt={2}>
          <FormControlLabel
            control={<Checkbox color="primary" checked disabled />}
            label={
              <Typography className="summary-renewal__checkbox-label">
                Other Amount
              </Typography>
            }
          />
        </Box>
      )}
    </Box>
  );
};

export default AddOns;
